export const powerReviewConfig = {
  locale: 'en_US',
  reviewWrite: 'pr-write',
  reviewDisplay: 'pr-reviewdisplay',
  reviewImageSnippet: 'pr-imagesnippet',
  reviewSnippet: 'pr-reviewsnippet',
  writeReviewUrl: 'write-a-review',
  scriptUrl: 'https://ui.powerreviews.com/stable/4.1/ui.js',
};
